import { render, staticRenderFns } from "./ReachChartV2.vue?vue&type=template&id=8c4e0c1c&scoped=true"
import script from "./ReachChartV2.vue?vue&type=script&lang=js"
export * from "./ReachChartV2.vue?vue&type=script&lang=js"
import style0 from "./ReachChartV2.vue?vue&type=style&index=0&id=8c4e0c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4e0c1c",
  null
  
)

export default component.exports